module.exports = __webpack_public_path__ + "static/media/peugeot.a365f917.png";